import { Palette } from '@woundtech/ui-colors';
import React from 'react';
import CustomButton from './CustomButton';
import NavigationButton from './NavigationButton';

export type ButtonProps = {
  color?: string;
  disabled?: boolean;
  label: string;
  onClick?: () => void;
  variant: 'navigation' | 'outlined' | 'text' | 'contained';
  size?: 'small' | 'medium' | 'large';
  startIcon?: string;
  endIcon?: string;
  fullWidth?: boolean;
  transformText?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  color,
  disabled = false,
  label,
  onClick,
  variant,
  size,
  startIcon = '',
  endIcon = '',
  fullWidth,
  transformText,
}) => {
  const props = {
    disabled,
    label,
    startIcon,
    endIcon,
    fullWidth,
    size,
    onClick,
  };
  switch (variant) {
    case 'navigation':
      return <NavigationButton {...props} />;
    case 'outlined':
      return (
        <CustomButton
          color={color || Palette.Blue.Main}
          variant="outlined"
          transformText={transformText}
          {...props}
        />
      );
    case 'text':
      return (
        <CustomButton
          color={color || Palette.Blue.Main}
          variant="text"
          transformText={transformText}
          {...props}
        />
      );
    case 'contained':
      return (
        <CustomButton
          color={color || Palette.Blue.Main}
          variant="contained"
          transformText={transformText}
          {...props}
        />
      );
    default:
      return null;
  }
};

export default React.memo(Button);
